import React from 'react'
import { useSelector } from 'react-redux'
import Route from './Route'
import RouteContext from './RouteContext'
import Loading from 'components/system/Loading'
import Snackbar from 'components/system/Snackbar'

import routerSelectors from 'store/selectors/router'

import HomeLayout from 'pages/HomeLayout'
import Home from 'pages/Home'
import Cauldron from 'pages/Cauldron'

const Router = ({

}) => {
  const route = useSelector(routerSelectors.route)

  if(!route) {
    return (
      <Loading />
    )
  }
  return (
    <RouteContext.Provider value={ route.name }>
      <Route segment="home" exact>
        <HomeLayout>
          <Home />
        </HomeLayout>
      </Route>
      <Route segment="cauldron">
        <Cauldron />
      </Route>
      <Snackbar />
    </RouteContext.Provider>
  )
}

export default Router